import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from '../../services/registration.service';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss'],
})
export class VerifyComponent implements OnInit {
  email = '';
  code = '';
  verifying = false;
  resending = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private registrationSvc: RegistrationService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
  }

  verify(): void {
    if (!this.email || !this.code.trim()) {
      this.toastr.warning('Enter the code you received.');
      return;
    }
    this.verifying = true;
    this.registrationSvc.verifyCode(this.email, this.code.trim()).subscribe({
      next: (res) => {
        this.verifying = false;
        if (res.isSuccess) {
          this.toastr.success('Verified! Your account is now pending admin approval.', '', { timeOut: 6000 });
          this.router.navigate(['/account/login']);
        } else {
          this.toastr.error(res.errors?.[0] ?? 'Verification failed.');
        }
      },
      error: (err) => {
        this.verifying = false;
        this.toastr.error(err?.error?.errors?.[0]?.messageEn ?? 'Verification failed.');
      },
    });
  }

  resend(): void {
    if (!this.email) return;
    this.resending = true;
    this.registrationSvc.sendVerificationCode(this.email).subscribe({
      next: (res) => {
        this.resending = false;
        if (res.isSuccess) this.toastr.success('A new code has been sent.');
        else this.toastr.error(res.errors?.[0] ?? 'Could not resend the code.');
      },
      error: () => { this.resending = false; this.toastr.error('Could not resend the code.'); },
    });
  }
}
